export enum DomainEnum {
  environment = 'environnement',
  solidarity_integration = 'solidarite-insertion',
  health = 'sante',
  culture_hobbies = 'culture-loisirs',
  education = 'education',
  sport = 'sport',
  humanitarian = 'humanitaire',
  live_together = 'vivre-ensemble',
  other = 'autre',
}

export const DomainNameMap: Record<DomainEnum, string> = {
  [DomainEnum.environment]: 'Environnement',
  [DomainEnum.solidarity_integration]: 'Solidarité',
  [DomainEnum.health]: 'Santé',
  [DomainEnum.culture_hobbies]: 'Culture et loisirs',
  [DomainEnum.education]: 'Education pour tous',
  [DomainEnum.sport]: 'Sport',
  [DomainEnum.humanitarian]: 'Développement international et aide humanitaire',
  [DomainEnum.live_together]: 'Mémoire et citoyenneté',
  [DomainEnum.other]: "Interventions d'urgence en cas de crise",
};
